export const german = {
    // General
    language: 'Sprache',
    de: 'Deutsch',
    en: 'Englisch',
    fr: 'French',
    it: 'Italian',

    save: 'Speichern',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    decline: 'Ablehnen',
    close: 'Schliessen',
    refresh: 'Aktualisieren',

    reconnectingHeader: 'Verbindung verloren',
    reconnectingMessage:
        'Verbindung zum Server verloren. Verbindung wird wiederhergestellt...',

    // Device Settings

    deviceSettings: 'Einstellungen',
    cam: 'Kamera',
    mic: 'Mikrofon',
    resolution: 'Auflösung',
    comModeNone: 'Nur Chat',
    comModeAudio: 'Audio',
    comModeBoth: 'Audio + Video',

    // Meeting

    agenda: 'Agenda',
    showboard: 'Showboard',
    minutes: 'Protokoll',
    documents: 'Dokumente',
    chat: 'Chat',
    show: 'Zeigen',

    startFullscreen: 'Vollbildmodus starten',
    stopFullscreen: 'Vollbildmodus beenden',
    startScreenShare: 'Bildschirm teilen',
    stopScreenShare: 'Bildschirm teilen beenden',
    leaveMeeting: 'Meeting verlassen',
    muteMic: 'Mikrofon stummschalten',
    unmuteMic: 'Mikrofon lautschalten',
    activateMic: 'Mikrofon aktivieren',
    startCam: 'Kamera einschalten',
    stopCam: 'Kamera ausschalten',
    activateCam: 'Kamera aktivieren',
    meetingInfo: 'Meeting Info',
    sharedApplications: 'Shared Applications',
    menu: 'Menu',

    msgRemoteMute: 'Sie wurden durch einen Berater stummgeschaltet.',
    msgKick: 'Sie wurden durch einen Berater aus dem Meeting entfernt.',

    bitrate: 'Bitrate',
    framerate: 'Framerate',
    packetLoss: 'Packet loss',

    // Recording
    recConfirmTitle: 'Aufzeichnung bestätigen',
    recConfirmMessage:
        'Wir möchten dieses Meeting gerne aufzeichnen. Sind Sie damit einverstanden?',

    // Errors

    connectionError: 'Verbindung zum Server ist fehlgeschlagen.',
    serviceNotFound: 'Dieser Service existiert nicht.',

    alcErrorDefault: 'alc Fehler',
    alcErrorMeetingDoesNotExist:
        'Das Meeting wurde bereits abgeschlossen oder existiert nicht.',
    alcErrorMeetingConnectionLost:
        'Verbindung zum Meeting-Server verloren. Bitte versuchen Sie es erneut.',
    alcErrorMeetingFull:
        'Die maximale Anzahl Teilnehmer im Meeting ist überschritten.',
    alcErrorWebinarParticipantsFull:
        'Die maximale Anzahl Teilnehmer im Webinar ist überschritten.',
    alcErrorNeedsRecordingConfirmation:
        'Sie können an diese Meeting nur teilnehmen wenn sie der Aufnahme zustimmen.',

    webRtcErrorDefault: 'WebRTC Fehler',
    webRtcErrorNotFound:
        'Keine Kamera / kein Mikrofon gefunden. Bitte überprüfen Sie, dass Ihre Kamera / Ihr Mikrofon angeschlossen ist und klicken Sie Aktualisieren.',
    webRtcErrorNotAllowed:
        'Bitte erlauben Sie in den Browsereinstellungen den Zugriff auf Ihr Mikrofon / Ihre Kamera. Aktivieren Sie danach Audio / Audio + Video.',
    webRtcErrorNotReadable:
        'Ihre Kamera wird von einer anderen Applikation verwendet. Bitte schliessen Sie diese Applikation oder wählen Sie eine andere Kamera.',
    webRtcErrorOverconstrained:
        'Ihre gespeicherte Kamera / Ihr gespeichertes Mikrofon konnte nicht gefunden werden. Bitte überprüfen Sie, dass Ihre Kamera / Ihr Mikrofon angeschlossen ist und klicken Sie Aktualisieren oder wählen Sie ein anderes Gerät.',
    webRtcErrorConnectionTimeout:
        'Zeitüberschreitung beim Verbinden zum Meeting Server',

    webRtcBrowserNotSupported:
        'Ihr Browser wird nicht unterstützt. Bitte verwenden Sie eine aktuelle Version von Chrome oder Firefox.',
    webRtcBrowserOutOfDate:
        'Ihre Version von {{browser}} ist veraltet und wird nicht mehr unterstützt. Bitte aktualisieren Sie Ihren Browser.',
    webRtcBrowserNonSafariIos:
        '{{browser}} wird auf iOS leider nicht untersützt. Bitte verwenden Sie eine aktuelle Version von Safari.',
    webRtcBrowserLegacyEdge:
        'Sie verwenden Edge Legacy. Diese Version von Edge ist veraltet und wird nicht mehr unterstüzt. Wir empfehlen Ihnen den neuen Edge zu verwenden, welchen Sie {{link}} herunterladen können.',
    webRtcBrowserIe:
        'Internet Explorer wird nicht unterstützt. Wir empfehlen Ihnen den neuen Edge zu verwenden, welchen Sie {{link}} herunterladen können.',

    // Communicator

    yourName: 'Ihr Name',
    yourEmail: 'Ihre E-Mail Adresse',
    invalidEmail: 'E-Mail Adresse ungültig.',
    enterNameAndEmail: 'Name und E-Mail Adresse angeben.',
    continue: 'Weiter',

    meetingTitle: 'Meeting',
    meetingCompleted: 'Meeting beendet',
    yourMeetingId: 'Ihre Meeting-ID',
    yourMeeting: 'Ihr Meeting',
    enterMeetingId: 'Geben Sie bitte Ihre erhaltene Meeting-ID ein.',
    meetingId: 'Meeting-ID',
    joinMeeting: 'Jetzt teilnehmen',
    meetingNotReady:
        'Ihr Termin findet erst am {{date}} um {{time}} statt. Bitte warten Sie oder versuchen Sie es später nochmals.',
    meetingExpired:
        'Der Termin ist nicht mehr gültig. Bitte vereinbaren Sie einen neuen Termin.',

    webinarTitle: 'Webinar',
    webinarCompleted: 'Webinar beendet',
    yourWebinarId: 'Ihre Webinar-ID',
    yourWebinar: 'Ihr Webinar',
    enterWebinarId: 'Geben Sie bitte Ihre erhaltene Webinar-ID ein.',
    webinarId: 'Webinar-ID',
    joinWebinar: 'Jetzt teilnehmen',
    webinarNotReady:
        'Das Webinar findet erst am {{date}} um {{time}} statt. Bitte warten Sie oder versuchen Sie es später nochmals.',
    webinarExpired: 'Der Termin ist nicht mehr gültig.',

    consultationTitle: 'Beratung',
    consultationCompleted: 'Beratung beendet',
    yourConsultationId: 'Ihre Beratungs-ID',
    yourConsultation: 'Ihre Beratung',
    enterConsultationId: 'Geben Sie bitte Ihre erhaltene Beratungs-ID ein.',
    consultationId: 'Beratungs-ID',
    joinConsultation: 'Jetzt teilnehmen',
    consultationNotReady:
        'Die Beratung findet erst am {{date}} um {{time}} statt. Bitte warten Sie oder versuchen Sie es später nochmals.',
    consultationExpired: 'Der Termin ist nicht mehr gültig.',

    // Webinars
    participants: 'Teilnehmer',
    requestSpeakerPermission: 'Sprecherlaubnis anfordern',
    cancelRequestSpeakerPermission: 'Sprecherlaubnis nicht mehr anfordern',
    endSpeakerPermission: 'Sprechen beenden',
    speakerPermission: 'Sprecherlaubnis',
    speakerPermissionConfirmation:
        'Ihnen wurde die Sprecherlaubnis erteilt. Bitte wählen Sie die gewünschte Kommunikationsform.',
    leaveWebinar: 'Webinar verlassen',

    // Contact Form
    contactForm: 'Kontaktanfrage',
    contactFormText: 'Oder senden Sie uns eine Kontaktanfrage',
    contactFormSuccess:
        'Vielen Dank für Ihre Kontaktanfrage. Wir werden uns mit Ihnen in Verbindung setzen.',
    send: 'Senden',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    message: 'Nachricht',
    desiredDate: 'Gewünschter Termin',
};
